//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setInstoreTemplateParams } from "../../features/instoreTemplates/instoreTemplatesSlice";
import { SortingStateOption } from "../../models/sorting";
import { useTranslation } from "react-i18next";
import MainTableHeaderCell from "../_layout/MainTableHeaderCell";
//#endregion

export default function InstoreTemplatesTableHeader() {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { instoreTemplate_params, loading } = useAppSelector(
    (state) => state.instoreTemplates
  );
  //#endregion

  //#region LOGIC

  // Set order sorting
  const sortChangedHandler = (option: SortingStateOption) => {
    if (option.column !== null) {
      dispatch(
        setInstoreTemplateParams({
          sort: JSON.stringify(option),
        })
      );
    } else {
      dispatch(setInstoreTemplateParams({ sort: undefined }));
    }
  };

  //#endregion

  //#region RENDER
  return (
    <thead>
      <tr>
        {/* edit and copy*/}
        <th
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs font-semibold text-gray-900"
          scope="col"
        />

        {/* active */}
        <MainTableHeaderCell
          headerText={t("rituals.active")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
        />

        {/* name */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.name")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="name"
          params={instoreTemplate_params}
        />

        {/* order_type */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.orderType")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="order_type"
          params={instoreTemplate_params}
        />

        {/* from */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.from")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          sortName="from"
          disabled={loading}
          params={instoreTemplate_params}
        />

        {/* until */}
        <MainTableHeaderCell
          sortChangedHandler={(option: SortingStateOption) =>
            sortChangedHandler(option)
          }
          headerText={t("rituals.until")}
          className="whitespace-nowrap pr-4 py-3.5 text-left text-xs text-gray-900"
          disabled={loading}
          sortName="until"
          params={instoreTemplate_params}
        />

        {/* Delete */}
        <th
          scope="col"
          className="whitespace-nowrap px-2 w-16 py-3.5 text-left text-xs font-semibold text-gray-900"
        />
      </tr>
    </thead>
  );
  //#endregion
}
